import { v4 as uuidv4 } from "uuid";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole, logError } from "../../utils/customLogger";
import { getOrgIdForFetchExternalWorklist } from "../../utils/organizationHelper";
import {
  createRequestOptions,
  getAuthHeaders,
  handleApiResponse,
} from "../utils/apiHelpers";

interface BatchTextNotesPayload {
  org_id: string;
  filename: string[];
  request_id: string;
  [key: string]: any;
}

export interface BatchTextNotesResponse {
  success: boolean;
  message: string;
  [key: string]: any;
}

/**
 * Sends batch text notes request for given filenames
 * @param filenames - Array of filenames to process text notes for
 * @param signal - Optional AbortSignal for canceling the request
 * @returns Promise with the API response
 */
export const batchTextNotesFromFilename = async (
  filenames: string[],
  signal?: AbortSignal,
): Promise<BatchTextNotesResponse> => {
  const orgId = getOrgIdForFetchExternalWorklist();

  const payload: BatchTextNotesPayload = {
    org_id: orgId,
    filename: filenames,
    request_id: uuidv4(),
  };

  const headers = await getAuthHeaders();
  const requestOptions = createRequestOptions(payload, headers, signal);

  try {
    const response = await fetch(
      API_ENDPOINTS.BATCH_TEXT_NOTES_FROM_FILENAME,
      requestOptions,
    );
    const result = await handleApiResponse(response);
    logDataToConsole("batchTextNotesFromFilename", result);
    return result;
  } catch (error) {
    if ((error as Error).name === "AbortError") {
      logDataToConsole("batchTextNotesFromFilename", "Request aborted");
      throw error;
    }
    logError(error as Error, "Error in batchTextNotesFromFilename");
    throw error;
  }
};
